import React from "react";
import { Box } from "native-base";
import { useNavigation } from "@react-navigation/core";
import { ContainerBaseCenter, FooterBase } from "../../styles/default";
import { SuccessContainer } from "./styles";
import { TextPage, TitlePage } from "../../styles/typograph";
import { Text, View } from "react-native";
import { Feather } from "@expo/vector-icons";
import { ButtonBase } from "../../components/buttons";
import { LOGIN } from "../../constants/routes";

const ForgotPasswordSuccess = ({ navigation }) => {
  const { navigate } = useNavigation();

  return (
    <Box style={{ flex: 1, backgroundColor: "#FF671D" }} safeArea>
      <ContainerBaseCenter>
        <SuccessContainer>
          <View style={{ justifyContent: "center", alignItems: "center" }}>
            <Feather name="check-circle" size={40} color="white" />
          </View>
          <TitlePage
            style={{ marginBottom: 10, marginTop: 15 }}
            color="white"
            center
          >
            Pronto!
          </TitlePage>
          <TextPage color="white" center>
            Um e-mail foi enviado para redefinir sua senha! Aguarde alguns
            minutos, caso não encontre cheque sua caixa de spam.
          </TextPage>
        </SuccessContainer>
      </ContainerBaseCenter>
      <FooterBase>
        <ButtonBase
          color="outline-white"
          title="VOLTAR AO LOGIN"
          onPress={() => navigate(LOGIN)}
        />
      </FooterBase>
    </Box>
  );
};

export default ForgotPasswordSuccess;
